
import { declination } from '@artmizu/utils';
import { computed, ref, useContext } from '@nuxtjs/composition-api';
import type { PartialDeep } from 'type-fest';
import TSPrice from '~/components/ts-components/TSPrice/TSPrice.vue';
import ProductStatus from '~/components/ProductStatus/ProductStatus.vue';
import type { Location } from '~/type/Location';
import type { NewOrder } from '~/type/NewOrder';
interface Props {
  color?: 'yellow' | 'grey';
  value: PartialDeep<NewOrder>;
  order: RequestType;
  city?: Location;
  productLink?: boolean;
  activeIds: number[];
}
type RequestType = Awaited<ReturnType<typeof context.$api.order.getOrderData>>;
const __sfc_main = {};
__sfc_main.props = {
  color: {
    key: "color",
    required: false,
    type: String,
    default: 'grey'
  },
  value: {
    key: "value",
    required: true,
    type: null
  },
  order: {
    key: "order",
    required: true,
    type: null
  },
  city: {
    key: "city",
    required: false,
    type: null
  },
  productLink: {
    key: "productLink",
    required: false,
    type: Boolean,
    default: true
  },
  activeIds: {
    key: "activeIds",
    required: true,
    type: Array
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const context = useContext();
  const hide = ref(true);
  const productListTitle = computed(() => {
    const str = declination(props.order.total.quantity, ['товар', 'товара', 'товаров']);
    return `${props.order.total.quantity} ${str} в заказе`;
  });
  const activeProductList = computed(() => {
    return props.order.product?.length ? props.order.product.filter(el => props.activeIds?.includes(el.id)) : [];
  });
  const summaryValue = computed(() => {
    if (props.value.delivery?.type?.allowSelectUserAddress && props.value.delivery.address?.type === 'courier') return props.value.delivery.address?.formatted;else if (props.value.delivery?.address?.type === 'pickup') return props.value.delivery?.address?.address;
  });
  return {
    hide,
    productListTitle,
    activeProductList,
    summaryValue
  };
};
__sfc_main.components = Object.assign({
  ProductStatus,
  TSPrice
}, __sfc_main.components);
export default __sfc_main;
